import React from 'react'

const AboutSection1 = () => {
    return (
        <div className="w-full xl:h-[70vh] h-[50vh] xl:px-35 px-10 flex items-end  pb-20" style={{ backgroundImage: "url('/new-final-data/about/Aboutus.webp')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <div className="">
                <h1 className="xl:text-7xl text-4xl font-bold text-white">About Us</h1>
                <p className="mt-2 text-lg text-gray-300">We help brands stand out in today’s competitive digital marketing landscape.</p>
            </div>
        </div>
    )
}

export default AboutSection1